import { registerComponent, executeScripts } from "helpers";
import WYATTElement from "wyatt";
import { checkForDuplicateIDs } from "dev-tools";

registerComponent(
  "live-region",
  class LiveRegion extends WYATTElement {
    constructor() {
      super();

      if (!this.ariaLive) {
        this.ariaLive = "polite";
      }

      this.moveStyles();
    }

    connectedCallback() {
      this.subscribe(
        WYATT.PubSub.events.updateDOM,
        this.conditionallyUpdateDOM.bind(this),
      );
    }

    conditionallyUpdateDOM(event) {
      const data = event?.detail;

      if (!data) {
        return;
      }

      const item = data.find(
        ({ liveRegion }) => liveRegion === this.dataset.liveRegion,
      );

      if (item) {
        const newDOM = new DOMParser()
          .parseFromString(item.html, "text/html")
          .querySelector(`[data-live-region="${this.dataset.liveRegion}"]`);
        if (newDOM) {
          executeScripts(newDOM);

          this.moveStyles(newDOM);
          this.replaceWith(newDOM);
          checkForDuplicateIDs();
        }
      }
    }

    moveStyles(DOM = this) {
      const assets = DOM.querySelectorAll(
        'link[rel="stylesheet"], [data-source]',
      );

      assets.forEach((asset) => {
        const fileName = this.fileName(asset);

        if (!fileName) {
          return;
        }

        if (WYATT.config.liveRegion.existingExternalAssets.includes(fileName)) {
          asset.remove();
        } else {
          document.head.appendChild(asset);
          WYATT.config.liveRegion.existingExternalAssets.push(fileName);
        }
      });
    }

    fileName(asset) {
      const source = asset.dataset.source || asset.src || asset.href;
      const assetMatch = source.match(/\/assets\/(.*?)\?/);

      return assetMatch ? assetMatch[1] : null;
    }
  },
);
